import { FvLinkButton, FvNum } from '@fv/client-components'
import { getEquipmentLabel } from '@fv/client-core'

import { useTypeNames } from '@/hooks/useTypeNames'
import type { Opportunity } from '@/types/Opportunity'

type Props = {
  opportunity: Opportunity
}
export const QuotingDescription = ({ opportunity }: Props) => {
  const { targetPrice, saltDetails } = opportunity
  const { alternateTypes, type } = opportunity.equipmentRequested

  const { equipmentName } = useTypeNames()
  const equipmentLabel = getEquipmentLabel({
    altEquipmentNames: alternateTypes?.map(equipmentName),
    equipmentName: equipmentName(type),
  })
  return (
    <div className="flex items-center gap-x-4 border-b border-dashed border-slate-300 pb-2">
      <p className="">
        You are quoting a {equipmentLabel}{' '}
        {targetPrice && (
          <>
            / Shipper target price is{' '}
            <span className="font-bold">${targetPrice}</span>
          </>
        )}
        {saltDetails && (
          <>
            / Shipper requested a{' '}
            <FvLinkButton
              theme="underlined"
              target="_blank"
              to={`/search?text=${saltDetails.referenceLoadId}`}
            >
              &apos;same as last time&apos;
            </FvLinkButton>{' '}
            price of{' '}
            <span className="underline underline-offset-4 decoration-fv-orange font-mono text-lg">
              <FvNum val={saltDetails.amount} currency={saltDetails.currency} />
            </span>
          </>
        )}
      </p>
    </div>
  )
}
